/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var EmployeesType;

(function (EmployeesType) {
  EmployeesType["CLERICAL_EMPLOYEES"] = "clericalEmployees";
  EmployeesType["MANUAL_EMPLOYEES"] = "manualEmployees";
  EmployeesType["TOTAL_EMPLOYEES"] = "totalEmployees";
})(EmployeesType || (EmployeesType = {}));